export type CurrencyRange = {min?: string | number; max?: string | number}

export function parseCurrencyAmount(value: string | number | undefined): number | undefined {
  if (value === undefined || String(value).trim() === '') return undefined
  if (typeof value === 'number') return value

  const text = value.trim()
  if (/^\d+(?:\.\d{1,2})?$/.test(text)) return Number(text)
  if (/^(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d{1,2})?$/.test(text)) {
    return Number(text.replace(/\./g, '').replace(',', '.'))
  }
  return NaN
}

export function validateCurrencyRange(range: CurrencyRange = {}) {
  const min = parseCurrencyAmount(range.min)
  const max = parseCurrencyAmount(range.max)
  if ([min, max].some((value) => value !== undefined && (!Number.isFinite(value) || value < 0))) {
    return 'Informe valores válidos, maiores ou iguais a zero, com até duas casas decimais.'
  }
  if (min !== undefined && max !== undefined && min > max) {
    return 'O valor mínimo não pode ser maior que o valor máximo.'
  }
  return ''
}
